var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArticle105 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 105,
  height: 105,
  viewBox: "0 0 105 105",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.5 10C26.2239 10 26 10.2239 26 10.5V86.5C26 88.4891 25.2098 90.3968 23.8033 91.8033C22.3968 93.2098 20.4891 94 18.5 94C16.5109 94 14.6032 93.2098 13.1967 91.8033C11.7902 90.3968 11 88.4891 11 86.5V55H16.5C16.7761 55 17 54.7761 17 54.5C17 54.2239 16.7761 54 16.5 54H10.5C10.2239 54 10 54.2239 10 54.5V86.5C10 88.7543 10.8955 90.9164 12.4896 92.5104C14.0837 94.1045 16.2457 95 18.5 95H86.5C88.7543 95 90.9163 94.1045 92.5104 92.5104C94.1045 90.9163 95 88.7543 95 86.5V10.5C95 10.2239 94.7761 10 94.5 10H26.5ZM86.5 94H22.5C23.2334 93.6089 23.9119 93.1089 24.5104 92.5104C26.1045 90.9163 27 88.7543 27 86.5V11H94V86.5C94 88.4891 93.2098 90.3968 91.8033 91.8033C90.3968 93.2098 88.4891 94 86.5 94Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.5 26C40.2239 26 40 26.2239 40 26.5V42.5C40 42.7761 40.2239 43 40.5 43H80.5C80.7761 43 81 42.7761 81 42.5V26.5C81 26.2239 80.7761 26 80.5 26H40.5ZM41 42V27H80V42H41ZM40 58.5C40 58.2239 40.2239 58 40.5 58H80.5C80.7761 58 81 58.2239 81 58.5C81 58.7761 80.7761 59 80.5 59H40.5C40.2239 59 40 58.7761 40 58.5ZM40 74.5C40 74.2239 40.2239 74 40.5 74H80.5C80.7761 74 81 74.2239 81 74.5C81 74.7761 80.7761 75 80.5 75H40.5C40.2239 75 40 74.7761 40 74.5Z",
  fill: "var(--icon-decorative-coral)"
})));
export default SvgArticle105;